import api from './api';

// The lab-test catalog and the tests recorded against visits.
//
// The visit form saves its lab cards along with the visit (patientService
// createVisit / updateVisit carry `visitLabTests`); the per-visit calls here
// are for working one test at a time, and the admin calls maintain the catalog.
const labTestService = {
    // Active tests with their fields, for the "Add Lab Test" dropdown.
    // `{ all: true }` (superadmin) includes inactive ones.
    getCatalog: async ({ all = false } = {}) => {
        const response = await api.get('/lab-tests', { params: all ? { all: 1 } : {} });
        return response.data;
    },

    // Every visit lab test of a patient, with visit dates, newest visit first.
    getPatientResults: async (patientId) => {
        const response = await api.get(`/lab-tests/patient/${patientId}/results`);
        return response.data;
    },

    // One field's values across a patient's visits, oldest first.
    getTrend: async (patientId, fieldId) => {
        const response = await api.get(`/lab-tests/patient/${patientId}/trend/${fieldId}`);
        return response.data;
    },

    // ---- one visit --------------------------------------------------------

    getVisitLabTests: async (visitId) => {
        const response = await api.get(`/visits/${visitId}/lab-tests`);
        return response.data;
    },

    // { labTestId, results: [{ labTestFieldId, value }], note }
    addVisitLabTest: async (visitId, data) => {
        const response = await api.post(`/visits/${visitId}/lab-tests`, data);
        return response.data;
    },

    // { results: [{ labTestFieldId, value }], note }
    updateVisitLabTest: async (visitId, visitLabTestId, data) => {
        const response = await api.put(`/visits/${visitId}/lab-tests/${visitLabTestId}`, data);
        return response.data;
    },

    removeVisitLabTest: async (visitId, visitLabTestId) => {
        const response = await api.delete(`/visits/${visitId}/lab-tests/${visitLabTestId}`);
        return response.data;
    },

    // ---- admin (superadmin) -------------------------------------------------

    createTest: async (data) => {
        const response = await api.post('/lab-tests', data);
        return response.data;
    },

    updateTest: async (id, data) => {
        const response = await api.put(`/lab-tests/${id}`, data);
        return response.data;
    },

    deleteTest: async (id) => {
        const response = await api.delete(`/lab-tests/${id}`);
        return response.data;
    },

    addField: async (testId, data) => {
        const response = await api.post(`/lab-tests/${testId}/fields`, data);
        return response.data;
    },

    updateField: async (testId, fieldId, data) => {
        const response = await api.put(`/lab-tests/${testId}/fields/${fieldId}`, data);
        return response.data;
    },

    deleteField: async (testId, fieldId) => {
        const response = await api.delete(`/lab-tests/${testId}/fields/${fieldId}`);
        return response.data;
    }
};

export default labTestService;
